import React, { useState, useEffect } from 'react'
import ImageAssets1 from '/img/subcategory.webp'

interface SubcategoryHeroSectionProps {
	subcategoryName?: string
	isNew?: boolean
	isPopular?: boolean
}

const SubcategoryHeroSection: React.FC<SubcategoryHeroSectionProps> = ({
	subcategoryName = 'Subcategoría Ejemplo',
	isNew = false,
	isPopular = false,
}) => {
	const [isVisible, setIsVisible] = useState(false)
	const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 })

	useEffect(() => {
		setIsVisible(true)
	}, [])

	const handleMouseMove = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
		const rect = e.currentTarget.getBoundingClientRect()
		setMousePosition({
			x: e.clientX - rect.left,
			y: e.clientY - rect.top,
		})
	}

	const getBadgeInfo = () => {
		if (isNew) return { text: 'NUEVO', show: true }
		if (isPopular) return { text: 'HOT', show: true }
		return { show: false }
	}

	const badgeInfo = getBadgeInfo()

	return (
		<section className='w-full relative overflow-hidden'>
			<div
				className='relative h-48 lg:h-56 bg-gradient-to-br from-red-600 via-red to-red-700 rounded-xl mx-4 lg:mx-6 shadow-xl border border-red-800'
				onMouseMove={handleMouseMove}
			>
				<div
					className='absolute inset-0 opacity-8 bg-gradient-to-r from-white to-transparent transition-all duration-500 ease-out'
					style={{
						background: `radial-gradient(circle at ${mousePosition.x}px ${mousePosition.y}px, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0.15) 30%, transparent 50%)`,
					}}
				/>

				<div className='absolute inset-0 opacity-3'>
					<div className='absolute top-4 left-4 w-16 h-16 border border-white rotate-45 transform animate-pulse' />
					<div className='absolute bottom-4 right-4 w-12 h-12 border border-white rotate-12 transform animate-pulse delay-150' />
				</div>

				<div className='relative z-10 h-full flex items-center justify-between p-6 lg:p-8'>
					<div
						className={`flex-1 transition-all duration-800 transform ${
							isVisible
								? 'translate-x-0 opacity-100'
								: '-translate-x-6 opacity-0'
						}`}
					>
						{badgeInfo.show && (
							<div className='inline-flex items-center gap-1 bg-white text-red-600 px-3 py-1 rounded-full text-xs font-bold mb-3 shadow-md animate-pulse border border-gray-300'>
								<span className='w-1.5 h-1.5 bg-red-600 rounded-full animate-ping' />
								{badgeInfo.text}
							</div>
						)}

						<h1 className='text-2xl lg:text-4xl xl:text-5xl font-black text-white leading-tight'>
							<span className='block uppercase tracking-wide'>
								{subcategoryName.split(' ')[0] || 'SUBCATEGORÍA'}
							</span>
							{subcategoryName.split(' ').slice(1).length > 0 && (
								<span className='block text-black drop-shadow-md uppercase tracking-wide text-xl lg:text-3xl xl:text-4xl'>
									{subcategoryName.split(' ').slice(1).join(' ')}
								</span>
							)}
						</h1>
					</div>

					<div
						className={`ml-6 transition-all duration-800 delay-200 transform ${
							isVisible
								? 'translate-x-0 opacity-100'
								: 'translate-x-6 opacity-0'
						}`}
					>
						<div className='relative group'>
							<div className='absolute -inset-2 bg-gradient-to-r from-white to-transparent rounded-xl blur-lg opacity-20 group-hover:opacity-30 transition-opacity duration-300' />

							<div className='relative bg-gradient-to-br from-white to-white rounded-xl p-3 transform group-hover:scale-105 transition-all duration-300 shadow-lg'>
								<img
									src={ImageAssets1}
									alt={`${subcategoryName} - SportCenter Shop`}
									className='w-24 h-24 lg:w-32 lg:h-32 xl:w-36 xl:h-36 object-cover rounded-lg'
								/>

								<div className='absolute inset-3 bg-gradient-to-t from-white/60 via-transparent to-transparent rounded-lg flex items-end opacity-0 group-hover:opacity-100 transition-opacity duration-200'>
									<div className='text-white p-2'>
										<div className='text-xs font-bold truncate max-w-20'>
											{subcategoryName}
										</div>
									</div>
								</div>
							</div>

							{badgeInfo.show && (
								<div className='absolute -top-1 -right-1 bg-black text-white px-2 py-0.5 rounded-full text-xs font-bold shadow-md animate-pulse border border-gray-300'>
									{badgeInfo.text}
								</div>
							)}
						</div>
					</div>
				</div>

				<div className='absolute bottom-0 left-0 w-full h-0.5 bg-gradient-to-r from-white via-gray-200 to-transparent' />
			</div>
		</section>
	)
}

export default SubcategoryHeroSection
